<ion-app
  *ngIf="
    (theme &&
      theme === 'default' &&
      (User$ | async) !== null &&
      !(User$ | async)?.session) ||
    (theme && theme === 'full')
  "
>
  <ion-split-pane contentId="main-content">
    <!--[when]="settingMenu"-->
    <ion-menu contentId="main-content" type="overlay" manuId="main">
      <ion-header>
        <ion-toolbar>
          <ion-title *ngIf="user">
            <!--    <ion-col size="3"> <img src="assets/logo.jpg" height="28px"></ion-col> -->
            AmicowinApp {{ version }}
            <ion-icon
              *ngIf="(status | async)?.connected"
              name="cellular"
            ></ion-icon>
            <ion-icon
              *ngIf="!(status | async)?.connected"
              name="cellular-outline"
            ></ion-icon>
          </ion-title>
          <!-- <ion-buttons slot="end">
          <ion-button (click)="menuToggle()">
            <ion-icon name="menu-outline"></ion-icon>
          </ion-button>
        </ion-buttons> -->
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-title> {{ user.code }} - {{ user.name }} </ion-title>
        <ion-list>
          <!--  <ion-button  *ngIf="selectedCliente" color="danger"   lines="none" detail="false"  size="full" (click)="unselectCliente()">
        <ion-icon slot="start" [ios]="'person' + '-outline'" [md]="'person' + '-sharp'"></ion-icon>
        <ion-label >{{selectedCliente.ragione_sociale}}</ion-label>
      </ion-button> -->
          <ion-menu-toggle
            auto-hide="false"
            *ngFor="let p of appButtons; let i = index"
          >
            <ion-button
              routerDirection="root"
              [routerLink]="[p.url]"
              lines="none"
              detail="false"
              routerLinkActive="selected"
              size="full"
            >
              <ion-icon
                slot="start"
                [ios]="p.icon + '-outline'"
                [md]="p.icon + '-sharp'"
              ></ion-icon>
              <ion-label>{{ p.title }}</ion-label>
            </ion-button>
          </ion-menu-toggle>
        </ion-list>
        <ion-list id="inbox-list" *ngIf="user">
          <ion-menu-toggle
            auto-hide="false"
            *ngFor="let p of appPages; let i = index"
          >
            <ion-item
              routerDirection="root"
              [routerLink]="[p.url]"
              lines="none"
              detail="false"
              routerLinkActive="selected"
            >
              <ion-icon
                slot="start"
                [ios]="p.icon + '-outline'"
                [md]="p.icon + '-sharp'"
              ></ion-icon>
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <ion-list id="inbox-list" *ngIf="user">
          <ion-menu-toggle
            auto-hide="false"
            *ngFor="let p of userPages; let i = index"
          >
            <ion-item
              routerDirection="root"
              [routerLink]="[p.url]"
              lines="none"
              detail="false"
              routerLinkActive="selected"
              *ngIf="
                (mostraCarrello(p) && !(p.id === 9)) ||
                (p.id === 9 && selectedCliente && isB2b)
              "
            >
              <ion-icon
                *ngIf="
                  !(p.id === 9 || p.id === 11) ||
                  (p.id === 9 && selectedCliente && isB2b)
                "
                slot="start"
                [ios]="p.icon + '-outline'"
                [md]="p.icon + '-sharp'"
              ></ion-icon>
              <ion-label
                *ngIf="
                  !(p.id === 9 || p.id === 11) ||
                  (p.id === 9 && selectedCliente && isB2b)
                "
                >{{ p.title }}</ion-label
              >

              <!-- Gestione budget id 11 -->
             <!--  <ion-icon
                *ngIf="p.id === 11 && isB2b"
                slot="start"
                [ios]="p.icon + '-outline'"
                [md]="p.icon + '-sharp'"
              ></ion-icon>
              <ion-label *ngIf="p.id === 11 && isB2b">{{ p.title }}</ion-label> -->

              <!-- fine gestione budget -->
              <ion-badge *ngIf="p.id === 1">{{ ordersToSend }}</ion-badge>
              <ion-badge *ngIf="p.id === 10">{{ ordersSended }}</ion-badge>
              <ion-spinner
                *ngIf="
                  (p.id === 2 || p.id === 3 || p.id === 4 || p.id === 6) &&
                  (loaders.ddt || loaders.prenotazioni || loaders.ordini)
                "
              ></ion-spinner>
              <ion-badge
                *ngIf="ordiniClienti && p.id === 2 && !loaders.ordini"
                >{{ ordiniClienti }}</ion-badge
              >
              <ion-badge *ngIf="!ordiniClienti && p.id === 2 && !loaders.ordini"
                >0</ion-badge
              >
              <ion-badge *ngIf="ddtClienti && p.id === 3 && !loaders.ddt">{{
                ddtClienti
              }}</ion-badge>
              <ion-badge *ngIf="!ddtClienti && p.id === 3 && !loaders.ddt"
                >0</ion-badge
              >
              <ion-badge
                *ngIf="prenotazioni && p.id === 4 && !loaders.prenotazioni"
                >{{ prenotazioni === "NaN" ? 0 : prenotazioni }}</ion-badge
              >
              <ion-badge
                *ngIf="!prenotazioni && p.id === 4 && !loaders.prenotazioni"
                >0</ion-badge
              >
              <ion-badge *ngIf="p.id === 0">{{ npezzi }}</ion-badge>

              <ion-badge *ngIf="!selectedCliente && p.id === 5">{{
                carrelli
              }}</ion-badge>
              <ion-badge *ngIf="p.id === 6 && !loaders.ordini">{{
                nrtestate
              }}</ion-badge>

              <ion-badge
                *ngIf="p.id === 9 && selectedCliente && isB2b"
              ></ion-badge>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <ion-menu-toggle auto-hide="false">
          <ion-button
            routerDirection="root"
            lines="none"
            detail="false"
            size="full"
            (click)="logout()"
          >
            <ion-icon slot="end" name="log-out-outline"></ion-icon>
            <ion-label>Logout</ion-label>
          </ion-button>
        </ion-menu-toggle>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
<ion-app
  *ngIf="
    (theme && theme === 'default' && (User$ | async)?.session) ||
    (theme && theme === 'full')
  "
>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
<!-- <ion-app  *ngIf="theme && theme==='default' && !userIsLogged">
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app> -->
<!-- LOGIN -->
<ion-app
  *ngIf="
    (theme && theme === 'default' && (User$ | async) === null) ||
    (theme && theme === 'full')
  "
>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
<!-- <ion-router-outlet *ngIf="theme && theme==='full'"  id="main-content">

</ion-router-outlet> -->
